import styled from "styled-components";

export const LogoImg = styled.img`
  margin: 4rem 0 0 4rem;
  width: 24.85rem;
  height: 1.6rem;

  @media only screen and (max-width: 1440px) {
    margin: 4rem auto;
  }
`;
